import { Component, Input } from '@angular/core';

@Component({
	selector: 'cng-vehicle-images',
	templateUrl: './vehicle-images.component.html',
	styleUrls: ['./vehicle-images.component.less']
})

export class ConfigureVehicleImagesComponent {

	@Input() vehicle: any = null;

	show_gallery: boolean = true;	
	timeout: any;
	/**
	 * Removes image from array.
	 *
	 * @param {number} index
	 */
	removeImage(index: number): void {
		this.vehicle.images.splice(index, 1);

		if (this.vehicle.images.length <= 1) {
			this.show_gallery = false;
			this.timeout = setTimeout(() => {
				this.show_gallery = true;
				
			}, 500)
		}
	}

	ngOnDestroy() : void {
		clearTimeout(this.timeout);
	}

}
